module.exports = "/_next/static/images/game-1-phone-gallery-08-26-1902-59c0ae24dae08cb828705866b34a08e6.jpg";